<div class="page-body">
  <div class="title-row">
    <div class="title">interaction {{index}}</div>
    <div class="date-time">
      <div class="date">{{interactionData[interactionSummary.contactTimeStamp] | customDateTime:'date'}}</div>
      <div class="time">{{interactionData[interactionSummary.contactTimeStamp] | customDateTime:'time'}}</div>
    </div>
  </div>

  <div class="summary-section">
    <div class="summary-title">Summary</div>
    <div class="summary-text">
      {{interactionData[interactionSummary.summary]}}
    </div>
    <div class="summary-details">
      <div class="summary-detail" *ngFor="let detail of details">
        <div class="detail-title">{{ detail.label }}:</div>
        <div class="detail-text">{{ interactionData[detail.uiKey] }}</div>
      </div>
    </div>
  </div>
  <div class="section-separator"></div>
  <div class="insights-section">
    <div class="insights-title">Insights</div>

    <div class="pill-section">

      <div class="pill-container">
        <div class="title">
          Interaction Time
        </div>

        <div class="pill-content">
          <div class="time-container">
            <div class="time-title">Total Duration</div>
            <div class="data">{{interactionData[interactionTime.totalDuration] | formatTimestamp: true: true }}</div>
          </div>
          <div class="separator"></div>
          <div class="time-container">
            <div class="time-title">Wait Time</div>
            <div class="data">{{interactionData[interactionTime.waitTime] | formatTimestamp: true: true }}</div>
          </div>
          <div class="separator"></div>
          <div class="time-container">
            <div class="time-title">Hold Time</div>
            <div class="data">{{interactionData[interactionTime.holdTime] | formatTimestamp: true: true }}</div>
          </div>
        </div>


      </div>

      <div class="pill-container">
        <div class="title">
          Customer Sentiment
        </div>

        <div class="pill-content">
          <img [src]="interactionData[customerSentiment.sentimentAtStart] | sentimentIcon" alt="forwardIcon" class="forward-icon" />

          <div class="time-container">
            <div class="time-title">Sentiment at Start</div>
            <div class="data">{{interactionData[customerSentiment.sentimentAtStart]}}</div>
          </div>

          <!-- <div class="separator"></div> -->
          <img src="assets/icons/arrow_forward_1.svg" alt="forwardIcon" class="forward-icon" />


          <img [src]="interactionData[customerSentiment.sentimentAtEnd] | sentimentIcon" alt="forwardIcon"
            class="forward-icon" />

          <div class="time-container">
            <div class="time-title">Sentiment at End</div>
            <div class="data">{{interactionData[customerSentiment.sentimentAtEnd]}}</div>
          </div>
        </div>


      </div>
    </div>
    <div class="insight-details">
      <table>
        <tr *ngFor="let row of tableRows">
          <th>{{ row.label }}</th>
          <td>{{ interactionData[row.uiKey] }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>